'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recompose = require('recompose');

var _lodash = require('lodash');

var _createHelper = require('./createHelper');

var _createHelper2 = _interopRequireDefault(_createHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dontUpdateForKeys = function dontUpdateForKeys(propKeys) {
    return (0, _recompose.shouldUpdate)(function (props, nextProps) {
        return !(0, _recompose.shallowEqual)((0, _lodash.omit)(nextProps, propKeys), (0, _lodash.omit)(props, propKeys));
    });
};

// Helper
// Lib
exports.default = (0, _createHelper2.default)(dontUpdateForKeys, 'dontUpdateForKeys');


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteRecompose/dontUpdateForKeys.js
// module id = 206
// module chunks = 0